// R1b-β Step 4 — Route gate that allows a caller-supplied set of role keys.
// Non-matching roles are redirected once to their role home (`user.home_route`); a would-be loop renders the
// access-denied page (see RoleDenied).
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import RoleDenied from "./RoleDenied";

export default function AllowedRolesRoute({ roles, children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-erf-cream">
        <div className="font-mono text-xs text-erf-dark/60">Authenticating…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (user && user.must_rotate_password) return <Navigate to="/auth/rotate" replace />;
  if (!(roles || []).includes(user.role_key)) return <RoleDenied user={user} />;
  return children;
}
